export default "/static/dashboard/build/app/img/v2/0bd2e6bc160343a3e97838bb015396f1.png";